import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';

export default function donateToCharity(params) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, appNameHeaderValue, additionalHeaders = {}, body = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of donateToCharity()');
    invariant(brandId, 'brandId is a required param of donateToCharity()');
    invariant(country, 'country is a required param of donateToCharity()');
    invariant(uberToken, 'uberToken is a required param of donateToCharity()');
    invariant(clientId, 'clientId is a required param of donateToCharity()');

    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self/donateToCharity`;
    const headers = {
        'Content-Type': 'application/json',
        'x-appname': appNameHeaderValue || brandId,
        ...additionalHeaders,
    };

    return labelRequest(
        authenticatedRequest(
            new Request(url, { headers: new Headers(headers), method: 'POST', body: JSON.stringify({ ...body }) }),
            uberToken,
            clientId,
            clientSecret,
        ),
        'donateToCharity',
    );
}
